








































import ExercisesFormWithLabel from '@/components/exercises/forms/ExercisesFormWithLabel.vue'
import ExercisesFormInput from '@/components/exercises/forms/ExercisesFormInput.vue'
import { withDefault, withUnit } from '@/components/exercises/measure/filters'

export default {
  components: {
    ExercisesFormWithLabel,
    ExercisesFormInput,
  },
  filters: {
    withDefault,
    withUnit,
  },
  props: {
    exercise: {
      type: Object,
      required: true,
      validator: obj => ['id', 'endBloodOxygenPerc', 'endHeartRateBpm'].every(key => key in obj),
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
}
